import { useState } from 'react';
import AdModal from '../components/AdModal';

export default function AdTest() {
  const [showEndgameAd, setShowEndgameAd] = useState(false);
  const [showMidgameAd, setShowMidgameAd] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-8">
      <div className="max-w-2xl w-full bg-slate-800/50 backdrop-blur-md border-4 border-yellow-500/50 rounded-lg p-12 shadow-2xl"
        style={{
          boxShadow: '0 0 40px rgba(234, 179, 8, 0.3), inset 0 2px 20px rgba(0,0,0,0.5)'
        }}
      >
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">📺 🎬 📡</div>
          <h1 className="text-4xl font-bold text-yellow-400 mb-3" style={{ textShadow: '0 0 20px rgba(234, 179, 8, 0.8)' }}>
            AdSense Test Page
          </h1>
          <p className="text-slate-300 text-lg mb-2">
            Test the Google AdSense integration without playing full games
          </p>
          <p className="text-slate-400 text-sm">
            Click the buttons below to see how ads appear in different contexts
          </p>
        </div>

        <div className="space-y-6">
          {/* End Game Ad Test */}
          <div className="bg-slate-900/50 border-2 border-yellow-500/30 rounded-lg p-6">
            <h3 className="text-xl font-bold text-yellow-300 mb-2">
              🏁 End Game Ad
            </h3>
            <p className="text-slate-400 text-sm mb-4">
              This ad appears after you complete a game (win, lose, or draw)
            </p>
            <button
              onClick={() => setShowEndgameAd(true)}
              className="w-full px-6 py-3 bg-gradient-to-r from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800 text-white rounded-lg font-bold transition-all border-2 border-yellow-400"
              style={{ boxShadow: '0 0 20px rgba(234, 179, 8, 0.5)' }}
            >
              Show End Game Ad
            </button>
          </div>

          {/* Mid Game Ad Test */}
          <div className="bg-slate-900/50 border-2 border-blue-500/30 rounded-lg p-6">
            <h3 className="text-xl font-bold text-blue-300 mb-2">
              ⏸️ Turn 20 Ad
            </h3>
            <p className="text-slate-400 text-sm mb-4">
              This ad appears at Turn 20 and Turn 40 during gameplay (for non-premium users)
            </p>
            <button
              onClick={() => setShowMidgameAd(true)}
              className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg font-bold transition-all border-2 border-blue-400"
              style={{ boxShadow: '0 0 20px rgba(59, 130, 246, 0.5)' }}
            >
              Show Turn 20 Ad
            </button>
          </div>

          {/* Info Box */}
          <div className="bg-pink-500/10 border-2 border-pink-500/30 rounded-lg p-6">
            <h3 className="text-lg font-bold text-pink-300 mb-2">
              ℹ️ About the Ads
            </h3>
            <ul className="text-slate-300 text-sm space-y-2">
              <li>• Ads use Google AdSense with auto-format (responsive)</li>
              <li>• 5-second countdown before users can skip</li>
              <li>• AdSense will try to show video ads when available</li>
              <li>• Premium users ($2.99) will never see these ads</li>
            </ul>
          </div>

          {/* Back Button */}
          <button
            onClick={() => window.location.href = '/'}
            className="w-full px-6 py-3 bg-slate-700 hover:bg-slate-600 text-slate-200 rounded-lg font-bold transition-all"
          >
            ← Back to Game
          </button>
        </div>
      </div>

      {/* Ad Modals */}
      <AdModal 
        isOpen={showEndgameAd} 
        onClose={() => setShowEndgameAd(false)}
        adType="endgame"
      />
      <AdModal 
        isOpen={showMidgameAd} 
        onClose={() => setShowMidgameAd(false)}
        adType="midgame"
      />
    </div>
  );
}
